export default {
  topWelcome: "📚 به بزرگترین مجموعه آموزش زبان خوش آمدید",

  topDescription:
    "با روش‌های جذاب و سرگرم‌کننده، یادگیری زبان را برای کودکان لذت‌بخش‌تر می‌کنیم. ✨",

  languageFa: "FA",
  languageEn: "EN",

  loginRegister: "ورود / ثبت نام",
  phoneNumber: "۰۹۱۲-۶۹۸-۵۱۷۱",

  cartPrice: " تومان",

  home: "صفحه اصلی",
  bookCategories: "دسته‌بندی ‌ها",
  aboutUs: "درباره ما",
  contactUs: "تماس با ما",

  rulesAndRegulations: "قوانین و مقررات",
  FAQ: "سوالات متداول",
  paymentMethod: "نحوه پرداخت",
  shippingMethod: "شیوه ارسال",
  returnProduct: "عودت کالا",

  mobileNumber: "شماره موبایل",

  orderList: "لیست سفارشات",

  logout: "خروج از حساب کاربری",


  logoAlt: "لوگوی",
  titleMenuInMobile: "منوی سایت",

  urls: {
    Main: "/",
    AboutUs: "/درباره-ما",
    Contact: "/تماس-با-ما",
    FAQ: "سوالات-متداول",
    Cart: "/fa/cart",
    ProductCategory: "/product-category",
    Order:"/fa/dashboard/orders",
    Profile:"/fa/dashboard/profile",
  }
};
